import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// material
import { Box, Card, Link, Typography, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
// utils
import { fCurrency } from '../../../utils/formatNumber';
// components
import Label from '../../../components/Label';
import { ColorPreview } from '../../../components/color-utils';

// ----------------------------------------------------------------------

const ProductImgStyle = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});

// ----------------------------------------------------------------------

ShopProductCard.propTypes = {
  product: PropTypes.object,
}; 

export default function ShopProductCard({ product }) {
  // const { name, cover, price, colors, status, priceSale } = product;

  return (
    <Card>
      <a style={{textDecoration: "none", color: "#000"}} href='#details' onClick={() => {
        localStorage.setItem("project_id", product.id);
        localStorage.setItem("project_json", JSON.stringify(product));
        window.location.href = './project-details'
      }}>
      <Box sx={{ pt: '100%', position: 'relative' }}>
     
          <Label
            variant="filled"
            color={(product.status === 'closed' && 'error') || 'info'}
            sx={{
              zIndex: 9,
              top: 16,
              right: 16,
              position: 'absolute',
              textTransform: 'uppercase',
            }}
          >
            {product.address_str}
          </Label>
      
        <ProductImgStyle alt={product.name} src={product.avatar === "" ? "https://images.unsplash.com/photo-1498184103684-bc1a70b0c068?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3869&q=80" : product.avatar} />
      </Box>

      <Stack spacing={2} sx={{ p: 3 }}>
        <Link to="#" color="inherit" underline="hover" component={RouterLink}>
          <Typography variant="subtitle2" noWrap>
            {product.profession}
          </Typography>
        </Link>

        <Stack direction="row" alignItems="center" justifyContent="space-between">
          {/* <ColorPreview colors="green" /> */}
          <Typography variant="subtitle1">
            <Typography
              component="span"
              variant="caption"
              sx={{
                // color: 'text.disabled',
                // textDecoration: 'line-through',
              }}
            >
              {product.budget} ({product.payment_mode})
            </Typography>
            </Typography>
        </Stack>
      </Stack>
      </a>
    </Card>
  );
}
